import img1 from '../img/Mask-group.png';
import img2 from '../img/Mask group(0).png';
import img3 from '../img/Mask group (1).png';
import img4 from '../img/Mask group (2).png';
import img5 from '../img/Mask group (3).png';
import img6 from '../img/Mask group (4).png';
import img7 from '../img/Mask group (5).png';
import img8 from '../img/Mask group (6).png';

const Data = [
  {
    id: 1,
    image: img1,
    price: 9.99,
    title: 'Fried Eggs',
    description: 'Made with eggs, lettuce, salt, oil and other ingredients.',
    category: 'Main Dishes',
  },
  {
    id: 2,
    image: img2,
    price: 15.99,
    title: 'Hawaiian Pizza',
    description: 'Made with eggs, lettuce, salt, oil and other ingredients.',
    category: 'Main Dishes',
  },
  {
    id: 3,
    image: img3,
    price: 7.25,
    title: 'Martinez Cocktail',
    description: 'Made with eggs, lettuce, salt, oil and other ingredients.',
    category: 'Drinks',
  },
  {
    id: 4,
    image: img4,
    price: 20.99,
    title: 'Butterscotch Cake',
    description: 'Made with eggs, lettuce, salt, oil and other ingredients.',
    category: 'Desserts',
  },
  {
    id: 5,
    image: img5,
    price: 5.89,
    title: 'Mint Lemonade',
    description: 'Made with eggs, lettuce, salt, oil and other ingredients.',
    category: 'Drinks',
  },
  {
    id: 6,
    image: img6,
    price: 18.05,
    title: 'Chocolate Icecream',
    description: 'Made with eggs, lettuce, salt, oil and other ingredients.',
    category: 'Breakfast',
  },
  {
    id: 7,
    image: img7,
    price: 12.55,
    title: 'Cheese Burger',
    description: 'Made with eggs, lettuce, salt, oil and other ingredients.',
    category: 'Breakfast',
  },
  {
    id: 8,
    image: img8,
    price: 12.99,
    title: 'Classic Waffles',
    description: 'Made with eggs, lettuce, salt, oil and other ingredients.',
    category: 'Desserts',
  },
];

export default Data;
